import { render, staticRenderFns } from "./AppointmentSummaryModal.vue?vue&type=template&id=24f09381&"
import script from "./AppointmentSummaryModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentSummaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports